<template>

    <transition
            name="exposures-fade"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut">

        <div class="exposures" id="exposures">


            <transition
                    name="exposures-fade"
                    enter-active-class="animated fadeIn">

                <!-- EXPOSURE GRID -->
                <div class="grid-component" v-if="!selectedSlug" key="grid" :class="{ 'deactivate': selectedSlug }">

                    <div class="banner">
                        <h3 class="heading" v-html="banner.heading" :style="{ color: cssPropColor('$color-primary') }"></h3>
                        <div class="copy" v-html="banner.copy"></div>
                    </div>

                    <div class="container">

                        <div class="row">

                            <div class="exposures-grid">

                                <div class="grid-item" @click="getExposure(exposure.exposure_slug)" v-for="(exposure, index) in exposures">
                                    <div class="image">
                                        <img :src="exposure.mobile.gridImageX1"
                                             :srcset="(exposure.mobile.gridImageX1 + ' 1x,' + exposure.mobile.gridImageX2 + ' 2x,' + exposure.mobile.gridImageX3 + ' 3x')"
                                             alt="" />
                                    </div>
                                    <h3 v-html="exposure.exposure_label"></h3>
                                </div>

                            </div>

                        </div>

                    </div>

                    <div class="container">
                        <div class="row">

                            <div class="nav-to-top">
                                <a @click="scrollToTop">Back to Top <span class="glyph">&#8593;</span></a>
                            </div>

                        </div>
                    </div>

                </div>
                <!-- END EXPOSURE GRID -->

                <!-- EXPOSURE DETAIL -->
                <mobile-content-exposure
                        :slug="selectedSlug"
                        :service="selectedService"
                        :premise="selectedPremise"
                        key="detail"
                        v-else></mobile-content-exposure>
                <!-- END EXPOSURE DETAIL -->

            </transition>

        </div>

    </transition>

</template>


<script>

    import MobileContentExposure from "./MobileContentExposure.vue";
    import { TweenMax, CSSPlugin, EasePack, ScrollToPlugin } from 'gsap';

    let vm = {};

    export default {

        name: 'mobile-content-exposures',

        components: { MobileContentExposure },

        data() {
            return {
                banner: {
                    heading: 'Is your equipment covered?',
                    copy: 'Select an exposure below to see how you can help protect your home.'
                },
                selectedSlug: null,
                selectedService: null,
                selectedPremise: null
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            exposures() {
                let _exposures = this.$dataStore.getters.getExposures;
                // alpha sort by label
                _exposures = _.sortBy(_exposures, ['exposure_label']);
                return _exposures;
            }

        },

        created() {
            console.info('%cmobile-content-exposures::created', 'color:dodgerblue;');

            vm = this;

            this.$eventBus.$on('exposures:enabled', function() {
                setTimeout(function() {
                    vm.animateGridItems(0);
                }, 200);
            });
            this.$eventBus.$on('exposure:closed', vm.exposureClosed);
            this.$eventBus.$on('exposure:return', vm.exposureReturn);
            this.$eventBus.$on('exposure:get', (slug) => vm.getExposure(slug));
            this.$eventBus.$on('slug:none', vm.selectNone);
        },

        mounted() {
            console.info('%cmobile-content-exposures::mounted', 'color:green;');

            vm = this;

            if (!vm.hasEntered) {
                $('.tab-content').addClass('inactive');
            }

            if (vm.selectedSlug) {
                $('.grid-component').addClass('inactive');
            } else {
                $('.grid-component').removeClass('inactive');
            }
        },

        watch: {
            selectedSlug: function(val) {
                if (val) {
                    console.log('selectedSlug[0]', val);
                    $('.grid-component').addClass('inactive');
                } else {
                    console.log('selectedSlug[1]', val);
                    $('.grid-component').removeClass('active');
                }
            }
        },

        methods:{

            getExposure(slug) {
                console.log('getExposure', slug);
                vm.selectedSlug = slug;

                let _exposure = _.find(vm.exposures, { 'exposure_slug': slug });

                gtag('event', 'Equipment Selection', {
                    'event_category': 'MBRe: Residential',
                    'event_label': _exposure.exposure_name
                });

                vm.selectedService = (_exposure.exposure_type === 'service-line');
                vm.selectedPremise = (_exposure.exposure_type === 'off-premise');

                //$('html,body').scrollTop(0);
                $('html, body').animate({ scrollTop: 0 }, 200);
            },

            exposureClosed() {
                vm.selectedSlug = null;

                $('html, body').animate({ scrollTop: 0 }, 200, function() {
                    vm.animateGridItems(300);
                });

            },

            exposureReturn() {
                vm.selectedSlug = null;

                $('html, body').animate({ scrollTop: 0 }, 200);
            },

            selectNone() {
                vm.selectedSlug = null;
            },

            animateGridItems(delay) {

                let _delay = delay || 0;

                function animateItems() {
                    let tl = new TimelineMax();

                    _.each($('.grid-item'), function(val, key) {

                        let _durationOffset = (vm.isOdd(key)) ? '-=0.3' : '-=0';

                        tl.fromTo($(val), 0.3, {
                            opacity: 0,
                            y: '-=80'
                        }, {
                            opacity: 1,
                            y: 0
                        }, _durationOffset);
                    });
                }

                setTimeout(function() {
                    animateItems();
                }, _delay);

            },

            scrollToTop() {
                $('html, body').animate({ scrollTop: 0 }, 400);
            },

            /**
             * @method getCSSColorVariable
             * @description
             * @param color
             * @return {string}
             */
            getCSSColorVariable(color) {
                let _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

                if (!_propVal) {
                    let _color = color.replace('--', '$');
                    _propVal = window.appTheme.colors[_color];
                }

                //console.log('_propVal', _propVal);

                return _propVal;
            },

            /**
             * @method cssPropColor
             * @description
             */
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            },

            isOdd(num) {
                return num % 2;
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .exposures {

        & .grid-component {
            max-height: 99999px;
            opacity: 1;
            transition: all .03s ease;

            &[v-cloak] {
                display: none !important;
            }

            &.inactive {
                max-height: 0;
                opacity: 0;
                transition: all 0s ease;
            }

            &.activate {
                max-height: 99999px;
                opacity: 1;
                transition: all 1s ease;
            }

            &.deactivate {
                max-height: 0 !important;
                opacity: 0 !important;
                transition: all 0s ease !important;
                overflow: hidden;
            }
        }

        & .container {
            width: 100%;
            padding: 0 20px;
            //overflow: hidden;
        }

        & .exposures-grid {
            margin: 1.250rem 0;
            display: flex;
            flex-flow: row wrap;
            justify-content: space-around;
        }

        & .grid-item {
            max-width: 150px;
            margin: 0 5px 1.250rem 5px;
            opacity: 0;

            & .image {
                line-height: 0;
                margin: 0 0 1.250rem 0;

                & > img {
                    max-width: 100%;
                    height: auto;
                }
            }

            & h3 {
                font-family: $font-univers-cond;
                font-size: 0.750rem;
                color: rgba(76,76,76, 1.0);
                text-transform: uppercase;
                line-height: 1.250;
                margin: 0 0 0 0;
                padding: 0 10px;
            }
        }
    }

    .banner {
        background-color: var(--color-primary);
        letter-spacing: initial;
        padding: 1.500rem 1.875rem;

        &.inactive {
            opacity: 0;
            transition: all 0s ease;
        }

        &.active {
            opacity: 1;
            transition: all 3s ease;
        }

        & h3 {
            font-family: $font-univers-bold;
            font-size: 0.875rem;
            font-weight: normal;
            letter-spacing: initial;
            color: $white-100;
            margin: 0 0 0.5rem 0;
            position: relative;

            &::before {
                content: "\e903";
                font-family: 'icomoon' !important;
                font-size: 1.750rem;
                speak: none;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                color: var(--color-primary);
                position: absolute;
                top: 50%;
                left: -43px;
                transform-origin: 50% 50%;
                transform: translateY(-50%);
            }
        }

        & .copy {
            font-family: $font-univers-std;
            font-size: 0.750rem;
            font-weight: normal;
            color: $white-100;
            line-height: 1.375;
            letter-spacing: initial;
            margin: 0 0 0 0;
        }
    }

    .nav-to-top {
        margin: 0 0 1rem 0;

        & a {
            font-family: $font-univers-cond;
            font-size: 0.813rem;
            line-height: 1;
            letter-spacing: initial;
            text-transform: uppercase;
            vertical-align: middle;
            color: $base-text-color;
        }

        & .glyph {
            font-family: $font-univers-bold;
            vertical-align: text-top;
            margin: 0 0 0 4px;
        }
    }




    /* MEDIA QUERIES - MOBILE FIRST */

    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) {

        .exposures {

            & .grid-item {
                max-width: 160px;
                margin: 0 5px 1.250rem 5px;
            }
        }
    }

    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {

        .exposures {

            & .grid-item {
                max-width: 180px;
                margin: 0 5px 1.250rem 5px;
            }
        }
    }

    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {

    }

    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 1200px) {

    }



</style>

<style lang="scss">
    [v-cloak] {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// MobileContentExposures.vue?17f54fd9